import React, { useState } from "react";
import { Box, Popover, Typography, Stack } from "@mui/material";
import moment from "moment";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "../../../styles/analytics/date-range.scss";
import PeriodPickers from "./period-pickers.jsx";

const CalendarMenu = ({
  currentPeriodRange,
  comparisonPeriodRange,
  setCurrentPeriodRange,
  setComparisonPeriodRange,
  currentPeriod,
  comparePeriod,
  setCurrentPeriod,
  setComparePeriod,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        className="date-container"
        spacing="10px"
        onClick={handleOpen}
      >
        <i class="fa fa-calendar" aria-hidden="true"></i>
        {currentPeriodRange && (
          <>
            <Typography
              component="span"
              sx={{ 
                fontSize: "16px", 
                color: "#4A4D52", 
                whiteSpace: "nowrap",
                maxWidth: "100%",
              }}
            >
              {`${moment(currentPeriodRange.startDate).format(
                "MM/DD/YYYY"
              )} - ${moment(currentPeriodRange.endDate).format("MM/DD/YYYY")}`}
            </Typography>
            {comparePeriod !== "none" && (
              <>
                {" "}
                <Typography
                  component="span"
                  sx={{ fontSize: "14px", color: "#6B7280" }}
                >
                  vs.
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontSize: "14px", 
                    color: "#6B7280", 
                    whiteSpace: "nowrap",
                    maxWidth: "100%",
                  }}
                >
                  {`${moment(comparisonPeriodRange.startDate).format(
                    "MM/DD/YYYY"
                  )} - ${moment(comparisonPeriodRange.endDate).format(
                    "MM/DD/YYYY"
                  )}`}
                </Typography>
              </>
            )}
          </>
        )}
      </Stack>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            boxShadow: "4px 4px 16px 0px rgba(0, 0, 0, 0.25)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            padding: "20px",
          },
        }}
      >
        <PeriodPickers
          currentPeriodRange={currentPeriodRange}
          comparisonPeriodRange={comparisonPeriodRange}
          setCurrentPeriodRange={setCurrentPeriodRange}
          setComparisonPeriodRange={setComparisonPeriodRange}
          currentPeriod={currentPeriod}
          setCurrentPeriod={setCurrentPeriod}
          comparePeriod={comparePeriod}
          setComparePeriod={setComparePeriod}
        />
      </Popover>
    </Box>
  );
};

export default CalendarMenu;
